"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'PageTitle';
var classes = {
  titleStyles: "".concat(PREFIX, "-titleStyles")
};
var StyledTypography = (0, _styles.styled)(_material.Typography)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({}, "&.".concat(classes.titleStyles), {
    fontSize: '40px',
    fontWeight: '300',
    letterSpacing: '1.33px',
    color: theme.palette.font.secondary
  });
});

var PageTitle = function PageTitle(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react.default.createElement(StyledTypography, {
    className: classes.titleStyles
  }, children);
};

var _default = PageTitle;
exports.default = _default;